import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import * as actionTypes from '../../../../store/actions/actionTypes';

const AdmissionList_Item_ManagerCustomUI_Comments = ({admission, customUI}) => {
    const dispatch = useDispatch();
    const showCommentsModal = () => dispatch({type: actionTypes.MODAL_COMMENTS_SHOW, admission: admission, customUI: customUI, commentsType: customUI.comment_type, modalHeader: customUI.modal_header, printEnable: customUI.print_enable, managerStatuses: customUI.comment_manager_statuses, ignoreCommentEnable: customUI.ignore_comment_enable});
    // The row may still belong to the previously selected hospital while the
    // columns are already rendered from the new one - its manager_customUI map
    // has no entry for this customUI id then. Render the neutral state instead
    // of crashing the whole list (IMP-889).
    const UIdata = (admission.manager_customUI || {})[customUI.id] || {};


    const renderCommentsBtn = () => {
        // Counter badge for attached files (shown when at least one file is attached).
        const filesCount = (UIdata.files || []).length;
        const counterBadge = filesCount > 0
            ? <span className="badge-counter">{filesCount}</span>
            : null;
        const withBadge = baseClass => counterBadge ? `${baseClass} btn-with-badge-counter` : baseClass;

        if (UIdata.comments_count > 0) {
            switch (UIdata.comments_status) {
                case 1:
                    return (
                        <button type="button" className={withBadge("btn-group-table-button btn btn-gray10 lifehouse-button-orange")} onClick={showCommentsModal}>{counterBadge}{UIdata.comments_count}</button>
                    );
                case 2:
                    return (
                        <button type="button" className={withBadge("btn-group-table-button btn lifehouse-button-green")} onClick={showCommentsModal}>{counterBadge}{UIdata.comments_count}</button>
                    )
                case 3:
                    return (
                        <button type="button" className={withBadge("btn-group-table-button btn btn-purple")} onClick={showCommentsModal}>{counterBadge}{UIdata.comments_count}</button>
                    )
                case 4:
                    return (
                        <button type="button" className={withBadge("btn-group-table-button btn btn-pink")} onClick={showCommentsModal}>{counterBadge}{UIdata.comments_count}</button>
                    )
            }
        }

        return (
            <button type="button" className={withBadge("btn-group-table-button btn btn-gray10")} onClick={showCommentsModal}>{counterBadge}-</button>
        );
    }

    return <td>{renderCommentsBtn()}</td>
}

export default AdmissionList_Item_ManagerCustomUI_Comments;